import { Dispatch } from "redux";
import { TransfersAction, TransfersActionTypes } from "../../types/transfers";
import {deleteTrannsferByRefNo, getTrannsferByIban} from '../../../services/Transfers/transfers'
import {Notify} from "components/Notification";
import { secureLocalStorageSet } from "../../../helpers";

export const setTableData = (value:Array<any>) => {
    return (dispatch: Dispatch<TransfersAction>) => {
      dispatch({
        type: TransfersActionTypes.CHANGE_TABLE,
        payload: value
      })
    }
  }

  
export const changeStatusHandler = () => {
  return (dispatch: Dispatch<TransfersAction>) => {
    dispatch({
      type: TransfersActionTypes.CHANGE_TABLE,
      payload: []
    })
  }
}


export const getTRanferByIban = async (ibanRef: String) => {
  return (dispatch: Dispatch<TransfersAction>) => {
    return new Promise(() => {
      dispatch({ type: TransfersActionTypes.GET_TRANFER_BY_IBAN_REQUEST })

      getTrannsferByIban(ibanRef)
        .then((response:any) => {
          dispatch({
            payload: {
              result: response,
            },
            type: TransfersActionTypes.GET_TRANFER_BY_IBAN_SUCCESS,
          })
          // localStorage.setItem("permissions", JSON.stringify(response.permissions))
          secureLocalStorageSet("permissions", response.permissions)
        })
        .catch((error: any) => {
          dispatch({
            error: {
              result: error.response,
            },
            type: TransfersActionTypes.GET_TRANFER_BY_IBAN_FAIL,
          })
          // Notify(error.response.data.messages[0].MESSAGE)
        })
    })
  }
}

export const deleteTransfer = (deleteRef: Array<any>) => {
  return (dispatch: Dispatch<TransfersAction>) => {
    return new Promise(() => {
      dispatch({ type: TransfersActionTypes.DELETE_TRANSFER_REQUEST })
        const req = {
            "trnRequestType": "DELETE",
            "description":"test icin sildim",
            "fileDescriptors": deleteRef
        }
        deleteTrannsferByRefNo(req)
          .then((response:any) => {
            dispatch({
              type: TransfersActionTypes.DELETE_TRANSFER_SUCCESS,
            })
          })
          .catch((error: any) => {
            dispatch({
              type: TransfersActionTypes.DELETE_TRANSFER_FAIL,
            })
          })
    })
  }
}


export const setSourceComingPage = (value:object) => {
  return (dispatch: Dispatch<TransfersAction>) => {
    dispatch({
      type: TransfersActionTypes.SET_SOURCE_COMING_PAGE,
      payload: value
    })
  }
}